import { useEffect, useMemo } from "react";
import { usePagination, useTable } from "react-table";
import { useSticky } from "react-table-sticky";
import { Input, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { Icon } from "../Component";

const Table = ({
  loading,
  columns,
  data,
  headerRow,
  pageSize: tempPageSize,
  fetchData,
  pageCount: tempPageCount,
  pageIndex: tempPageIndex,
  notShowPagi,
  customRow,
  onRowClick,
  onRowDoubleClick,
  conditionHighlightRow,
  isRotate = false,
  style
}) => {
  const tableInstance = useTable(
    {
      columns: useMemo(() => columns, [columns]),
      data: useMemo(() => data, [data]),
      manualPagination: true,
      pageCount: tempPageCount !== undefined ? tempPageCount : 0,
      initialState: {
        pageSize: tempPageSize || 10,
        pageIndex: tempPageIndex !== undefined ? tempPageIndex : 0,
      },

    },
    usePagination,
    useSticky
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize, pageIndex },
  } = tableInstance;
  useEffect(() => {
    if (fetchData) {
      fetchData({ pageIndex, pageSize });
    }
  }, [fetchData, pageIndex, pageSize]);

  return (
    <>

      {loading ? (
        <div className="text-center" style={{ padding: "10px 0px" }}>
          <span className="text-silent">Loading...</span>
        </div>
      ) : (
        <table
          {...getTableProps()}
          className={`table-bordered w-100 table table-responsive table-stripped sticky ${isRotate ? 'rtable--flip' : ''}`}
          style={style}
        >
          <thead>
            {
              // Loop over the header rows
              headerGroups.map((headerGroup) => (
                // Apply the header row props
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {
                    // Loop over the headers in each row
                    headerGroup.headers.map((column) => (
                      // Apply the header cell props
                      <th
                        {...column.getHeaderProps()}
                        className={column.className || ""}
                      >
                        <span>{
                          // Render the header
                          column.render("Header")
                        }</span>
                      </th>
                    ))
                  }
                </tr>
              ))
            }

          </thead>
          {/* Apply the table body props */}
          <tbody {...getTableBodyProps()}>
            {headerRow ? headerRow : null}

            {
              // Loop over the table rows
              rows.map((row, i) => {
                // Prepare the row for display
                prepareRow(row);
                return (
                  // Apply the row props
                  <tr
                    {...row.getRowProps()}
                    className={`
                    ${row?.original?.redFlag ? "text-danger " : ""} 
                    ${onRowClick || onRowDoubleClick ? 'cursor-pointer ' : ''} 
                    ${conditionHighlightRow?.(row.original)} 
                    `}
                    {...(onRowClick ? { onClick: () => onRowClick(row.original, i) } : {})}
                    {...(onRowDoubleClick ? { onDoubleClick: () => onRowDoubleClick(row.original, i) } : {})}
                  >
                    {
                      // Loop over the rows cells
                      row.cells.map((cell) => {
                        // Apply the cell props
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={`
                            ${cell?.column?.className || ''} 
                          `}
                          >
                            <span>{
                              // Render the cell contents
                              cell.render("Cell")
                            }</span>
                          </td>
                        );
                      })
                    }
                  </tr>
                );
              })
            }

            {data.length === 0 && loading === false ? (
              <tr>
                <td colSpan={10000}>
                  <div className="text-center">
                    <span className="text-silent">Không có dữ liệu</span>
                  </div>
                </td>
              </tr>

            ) : (
              <></>
            )}
            {customRow ? customRow() : <></>}

          </tbody>

        </table>
      )}

      {notShowPagi ? (
        <></>
      ) : (
        <div className="pagination mt-2">
          <Pagination aria-label="Page navigation example">
            <PaginationItem disabled={!canPreviousPage}>
              <PaginationLink
                className="page-link-prev"
                onClick={(ev) => {
                  ev.preventDefault();
                  gotoPage(0);
                }}
                href="#prev"
              >
                <Icon name="first" />
                <span>First</span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem disabled={!canPreviousPage}>
              <PaginationLink
                className="page-link-prev"
                onClick={(ev) => {
                  ev.preventDefault();
                  previousPage();
                }}
                href="#prev"
              >
                <Icon name="chevrons-left" />
                <span>Previous</span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem disabled={!canNextPage}>
              <PaginationLink
                className="page-link-next"
                onClick={(ev) => {
                  ev.preventDefault();
                  nextPage();
                }}
                href="#next"
              >
                <span>Next</span>
                <Icon name="chevrons-right" />
              </PaginationLink>
            </PaginationItem>
            <PaginationItem disabled={!canNextPage}>
              <PaginationLink
                className="page-link-next"
                onClick={(ev) => {
                  ev.preventDefault();
                  gotoPage(pageCount - 1);
                }}
                href="#next"
              >
                <span>Last</span>
                <Icon name="last" />
              </PaginationLink>
            </PaginationItem>
          </Pagination>

          <div className="ml-2 mr-2 d-flex justify-content-center align-items-center">
            <span>
              Page{" "}
              <strong>
                {(pageIndex || 0) + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
          </div>
          <Input
            style={{ width: 200 }}
            type="select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </Input>
        </div>
      )}
    </>
  );
};

export default Table;
